export const TYPE_BOOLEAN = 'boolean' as const;
export const TYPE_NUMBER = 'number' as const;
